<div class="inner-content" padding="">
  <div *ngIf="!platform.is('mobile')" class="modal-close-btn">
    <ion-icon name="close" (click)="closeModal()"></ion-icon>
  </div>
  <div text-center>
    <div font-medium style="font-size: 16px !important">
      Set up your pick up time
    </div>
    <div style="font-size: 12px; color: #5b7583">
      You can book a date between tomorrow & the next 30 days
    </div>
  </div>
  <ion-grid>
    <ion-row>
      <ion-col size="12" text-center>
        <ion-text font-bold text-small> PICKUP DATE </ion-text>
      </ion-col>
      <ion-col size="12">
        <ion-radio-group [(ngModel)]="selectedTimeSlotId">
          <ion-grid no-padding>
            <ion-row>
              <ion-col
                (click)="selectTimeSlot(time)"
                *ngFor="let time of timeSlots"
                size="3"
              >
                <div class="date" card-like="">
                  <div
                    class="item-radio-selectable"
                    [ngClass]="{
                      'item-radio-selected': time?.id == selectedTimeSlotId
                    }"
                  >
                    <div style="padding-top: 8px">
                      <ion-radio
                        mode="ios"
                        class=""
                        [value]="time.id"
                      ></ion-radio>
                      <ion-text color="medium" text-small *ngIf="time?.isToday"
                        >Today</ion-text
                      >
                      <ion-text
                        color="medium"
                        text-small
                        *ngIf="time?.isTomorrow"
                        >Tomorrow</ion-text
                      >
                      <ion-text
                        color="medium"
                        text-small
                        *ngIf="!time?.isToday && !time?.isTomorrow"
                      >
                        {{ time?.startTime | date: "d MMM" }}
                      </ion-text>
                    </div>
                  </div>
                </div>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-radio-group>
      </ion-col>
      <ion-col font-bold="" size="12" text-small text-center>
        <ion-text color="primary" style="font-size: 12px"
          >The pickup will be done between 8AM - 6PM</ion-text
        >
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
<ion-footer>
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-button
          [color]="'primary'"
          size="large"
          expand="block"
          [disabled]="!selectedTimeSlotId"
          (click)="updateTimeSlot()"
          >Save</ion-button
        >
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
